// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-management-objects-common-ObjectCardLayout-module__formRoot--VxivW {
  height: 100%;
  overflow: hidden;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.src-pages-management-objects-common-ObjectCardLayout-module__formColumnRoot--UcnFp {
  height: 100%;
  overflow: hidden;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.src-pages-management-objects-common-ObjectCardLayout-module__tabsContainer--uvBjf {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}
.src-pages-management-objects-common-ObjectCardLayout-module__tabsContainer--uvBjf .ant-tabs-nav {
  padding-inline: 16px;
  margin-top: 8px;
  margin-bottom: 0;
}
.src-pages-management-objects-common-ObjectCardLayout-module__tabsContainer--uvBjf .ant-tabs-content-holder {
  flex: 1;
  overflow: auto;
}
.src-pages-management-objects-common-ObjectCardLayout-module__tabContent--MAGlR {
  margin-top: 16px;
  flex: 1;
  min-height: 0;
  overflow: auto;
}
.src-pages-management-objects-common-ObjectCardLayout-module__tabPaneInset--cBuoS {
  padding: 0 16px;
}
.src-pages-management-objects-common-ObjectCardLayout-module__commonBlock--jvjd1 {
  max-width: 880px;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
}
.src-pages-management-objects-common-ObjectCardLayout-module__fieldsHost--wsE1K {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 16px;
  position: relative;
}
.src-pages-management-objects-common-ObjectCardLayout-module__fieldsStack--_ixWI {
  max-width: 880px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
}
.src-pages-management-objects-common-ObjectCardLayout-module__hidden--TY6Im {
  display: none !important;
}
/*# sourceMappingURL=ObjectCardLayout.module.css.map */`, "",{"version":3,"sources":["webpack://./ObjectCardLayout.module.less","webpack://./src/pages/management/objects/common/ObjectCardLayout.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;ACCF;ADEA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;ACAF;ADGA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;ACDF;ADJA;EAOI,oBAAA;EACA,eAAA;EACA,gBAAA;ACAJ;ADTA;EAaI,OAAA;EACA,cAAA;ACDJ;ADKA;EACE,gBAAA;EACA,OAAA;EACA,aAAA;EACA,cAAA;ACHF;ADMA;EACE,eAAA;ACJF;ADOA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;ACLF;ADQA;EACE,OAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;ACNF;ADSA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;ACPF;ADUA;EACE,wBAAA;ACRF;AACA,sDAAsD","sourcesContent":[".formRoot {\n  height: 100%;\n  overflow: hidden;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.formColumnRoot {\n  height: 100%;\n  overflow: hidden;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.tabsContainer {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  height: 100%;\n  overflow: hidden;\n  :global(.ant-tabs-nav) {\n    padding-inline: 16px;\n    margin-top: 8px;\n    margin-bottom: 0;\n  }\n\n  :global(.ant-tabs-content-holder) {\n    flex: 1;\n    overflow: auto;\n  }\n}\n\n.tabContent {\n  margin-top: 16px;\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n\n.tabPaneInset {\n  padding: 0 16px;\n}\n\n.commonBlock {\n  max-width: 880px;\n  padding: 0 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n.fieldsHost {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding: 0 16px;\n  position: relative;\n}\n\n.fieldsStack {\n  max-width: 880px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n.hidden {\n  display: none !important;\n}\n",".formRoot {\n  height: 100%;\n  overflow: hidden;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n.formColumnRoot {\n  height: 100%;\n  overflow: hidden;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n.tabsContainer {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  height: 100%;\n  overflow: hidden;\n}\n.tabsContainer :global(.ant-tabs-nav) {\n  padding-inline: 16px;\n  margin-top: 8px;\n  margin-bottom: 0;\n}\n.tabsContainer :global(.ant-tabs-content-holder) {\n  flex: 1;\n  overflow: auto;\n}\n.tabContent {\n  margin-top: 16px;\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n.tabPaneInset {\n  padding: 0 16px;\n}\n.commonBlock {\n  max-width: 880px;\n  padding: 0 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 32px;\n}\n.fieldsHost {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding: 0 16px;\n  position: relative;\n}\n.fieldsStack {\n  max-width: 880px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 32px;\n}\n.hidden {\n  display: none !important;\n}\n/*# sourceMappingURL=ObjectCardLayout.module.css.map */"],"sourceRoot":""}]);
// Exports
export var formRoot = `src-pages-management-objects-common-ObjectCardLayout-module__formRoot--VxivW`;
export var formColumnRoot = `src-pages-management-objects-common-ObjectCardLayout-module__formColumnRoot--UcnFp`;
export var tabsContainer = `src-pages-management-objects-common-ObjectCardLayout-module__tabsContainer--uvBjf`;
export var tabContent = `src-pages-management-objects-common-ObjectCardLayout-module__tabContent--MAGlR`;
export var tabPaneInset = `src-pages-management-objects-common-ObjectCardLayout-module__tabPaneInset--cBuoS`;
export var commonBlock = `src-pages-management-objects-common-ObjectCardLayout-module__commonBlock--jvjd1`;
export var fieldsHost = `src-pages-management-objects-common-ObjectCardLayout-module__fieldsHost--wsE1K`;
export var fieldsStack = `src-pages-management-objects-common-ObjectCardLayout-module__fieldsStack--_ixWI`;
export var hidden = `src-pages-management-objects-common-ObjectCardLayout-module__hidden--TY6Im`;
export default ___CSS_LOADER_EXPORT___;
